import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/avatar-placeholder.png'


const _withScopeId = n => (_pushScopeId("data-v-5f546caa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "customer-list-section" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"title\" data-v-5f546caa><p class=\"title-text\" data-v-5f546caa>เบอร์โทรศัพท์มือถือนี้</p><p class=\"title-text\" data-v-5f546caa>ถูกลงทะเบียนแล้ว</p></div><div class=\"sub-title\" data-v-5f546caa><p class=\"sub-title-text\" data-v-5f546caa>หากปัจจุบันเบอร์โทรศัพท์มือถือนี้เป็นของคุณ</p><p class=\"sub-title-text\" data-v-5f546caa>กรุณา &quot;ยืนยัน&quot; เพื่อดำเนินการแก้ไขต่อ</p></div><p class=\"customer-list-text\" data-v-5f546caa>ชื่อบัญชีที่ใช้โทรศัพท์มือถือนี้</p>", 3)
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "customer-list-container" }
const _hoisted_7 = { class: "customer-list-item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "customer-list-item-profile" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "customer-list-item-profile-image",
    src: _imports_0
  })
], -1))
const _hoisted_9 = { class: "customer-list-item-info" }
const _hoisted_10 = { class: "customer-list-item-info-name" }
const _hoisted_11 = { class: "customer-list-item-info-tel" }
const _hoisted_12 = { class: "footer" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("ยืนยัน")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("ยกเลิก")

export function render(_ctx, _cache) {
  const _component_q_btn = _resolveComponent("q-btn")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customerList, (customer) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("p", _hoisted_10, _toDisplayString(customer.firstName) + " " + _toDisplayString(customer.lastName), 1),
              _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.formatMobileNumber(customer.mobileNumber)), 1)
            ])
          ]))
        }), 256))
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_q_btn, {
        class: "btn btn-confirm",
        unelevated: "",
        type: "button",
        disabled: _ctx.isSubmitting,
        onClick: _ctx.handleSubmit
      }, {
        default: _withCtx(() => [
          _hoisted_13
        ]),
        _: 1
      }, 8, ["disabled", "onClick"]),
      _createVNode(_component_q_btn, {
        class: "btn btn-cancel",
        unelevated: "",
        type: "button",
        onClick: _ctx.handleCancel
      }, {
        default: _withCtx(() => [
          _hoisted_14
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}